import { format, parse } from "date-fns";
import { NavLink } from "react-router-dom";
import { de } from "date-fns/locale";
import clubInfo from "../../../../../static/clubInfo";
import { getTeamLogo } from "../../../../../static/logos/TeamLogos";
import { useIsMatchFinished } from '../../../../../hooks/useIsMatchFinished';
import "./MatchCard.css";

function formatGermanDate(dateStr) {
  const date = parse(dateStr, "dd.MM.yyyy", new Date());
  const formatted = format(date, "eee d. MMM", { locale: de });
  return formatted.toUpperCase();
}

export default function MatchCard({ match }) {
  const currentDate = new Date();
    const isMatchFinished = useIsMatchFinished(match);

  return (
    <NavLink to={`/spiele/${match.id}`} className="spiele-page__match-link">
      <div key={match.id} className="spiele-page__match">
        <div className="spiele-page__match-header">
          <h2 className="spiele-page__match-date">
            {formatGermanDate(match.date)}
          </h2>
          {(isMatchFinished) ? (
            <h2 className="spiele-page__match-beendet">beendet</h2>
          ) : (
            <h2 className="spiele-page__match-time">
              {match.game_time}
            </h2>
          )}
        </div>
        <div className="spiele-page__match-banner">
          <div className="spiele-page__match-banner__first-row">
            <div className="spiele-page__team">
              <div className="spiele-page__logo spiele-page__logo-home">
                <img
                  src={getTeamLogo(match.home_team)}
                  alt={`${match.home_team} logo`}
                />
              </div>
              <div className="spiele-page__team-home">
                <span>
                  {
                    clubInfo.find(
                      (clubee) =>
                        clubee.clubee_name === match.home_team,
                    )?.details.club_name
                  }
                </span>
              </div>
              {(isMatchFinished) ? (
                <div className="spiele-page__points spiele-page__points-home">
                  <span>{match.home_score}</span>
                </div>
              ) : (
                <div className="spiele-page__points-placeholder spiele-page__points-placeholder-home"></div>
              )}
            </div>
            <div className="spiele-page__team">
              {(isMatchFinished) ? (
                <div className="spiele-page__points spiele-page__points-away">
                  <span>{match.away_score}</span>
                </div>
                    ) : (
                      <div className="spiele-page__points-placeholder spiele-page__points-placeholder-away"></div>
                    )}
                    <div className="spiele-page__team-away">
                      <span>
                        {
                          clubInfo.find(
                            (clubee) =>
                              clubee.clubee_name === match.away_team,
                          )?.details.club_name
                        }
                      </span>
                    </div>
                    <div className="spiele-page__logo spiele-page__logo-away">
                      <img
                        src={getTeamLogo(match.away_team)}
                        alt={`${match.away_team} logo`}
                      />
                    </div>
                  </div>
                </div>
                <div className="spiele-page__match-banner__second-row">
                  <div className="spiele-page__team">
                    <div className="spiele-page__team-home__second_row">
                      <span>{match.home_team}</span>
                    </div>
                  </div>
                  <div className="spiele-page__team">
                    <div className="spiele-page__team-away__second_row">
                      <span>{match.away_team}</span>
                    </div>
                  </div>
          </div>
        </div>
      </div>
    </NavLink>
  )
}
